import React from 'react';
import PropTypes from 'prop-types';
import ContentEditable from 'react-contenteditable';

function TextEditable({ children, setContent, disabled, tagName = 'span' }) {
    return (
        <ContentEditable
            html={children}
            disabled={disabled}
            onChange={(e) => setContent(e.target.value)}
            tagName={tagName}
            // When disabled, contenteditable="false" is rendered. FocusScope from
            // @react-aria/focus matches [contenteditable] as tabbable even when the
            // value is "false", causing Tab to silently skip over non-focusable elements.
            // tabIndex="-1" explicitly excludes these nodes from FocusScope's TreeWalker
            // and from the browser's natural tab order.
            tabIndex={disabled ? -1 : undefined}
        />
    );
}

TextEditable.propTypes = {
    children: PropTypes.string.isRequired,
    setContent: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    tagName: PropTypes.string,
};

TextEditable.defaultProps = {
    disabled: false,
    tagName: 'span',
};

export default React.memo(TextEditable);
